import gql from 'graphql-tag'

export const fetchCommercialBaseList = () => {
	return {
		query: gql`
			{
				commercial_base: conf_comercial_base(where: { active: { _eq: 1 } }) {
					id
					name: base
				}
			}
		`
	}
}
